import { render, staticRenderFns } from "./MatterCompetencesModal.vue?vue&type=template&id=2334f63a"
import script from "./MatterCompetencesModal.vue?vue&type=script&lang=js"
export * from "./MatterCompetencesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports